"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletPOI = void 0;
const engine_1 = require("@railgun-community/engine");
const poi_constants_1 = require("./poi-constants");
const temp_test_poi_node_interface_1 = require("./temp-test-poi-node-interface");
const wallet_poi_node_interface_1 = require("./wallet-poi-node-interface");
class WalletPOI {
    static init(poiNodeURL, customLists, engine) {
        const poiNodeInterface = (0, engine_1.isDefined)(poiNodeURL)
            ? new wallet_poi_node_interface_1.WalletPOINodeInterface(poiNodeURL, engine)
            : // TODO: remove temp tester
                new temp_test_poi_node_interface_1.TempTestPOINodeInterface(engine);
        const poiLists = [...poi_constants_1.POI_REQUIRED_LISTS, ...customLists];
        engine_1.POI.init(poiLists, poiNodeInterface);
        this.started = true;
    }
}
exports.WalletPOI = WalletPOI;
WalletPOI.started = false;
